import { ApiTask, LogLevelFilter } from '@/entities/task/api/tasksApi'
import { TaskLogFilter } from '../ui/lib/taskTypes'
import { TaskLog, TaskLogsSummary } from '@/entities/task/model/taskTypes'

export const taskLogsKeys = {
  all: ['taskLogs'] as const,
  task: (taskId: string) => [...taskLogsKeys.all, taskId] as const,
  filter: (taskId: string, filter: TaskLogFilter) =>
    [...taskLogsKeys.task(taskId), filter] as const,
}

export const mapFilterToLevel = (
  filter: TaskLogFilter
): LogLevelFilter | undefined => {
  switch (filter) {
    case 'info':
      return LogLevelFilter.INFO
    case 'warning':
      return LogLevelFilter.WARNING
    case 'error':
      return LogLevelFilter.ERROR
    default:
      return undefined
  }
}

export const getTaskLogsNextPageParam = (
  pages: ApiTask[],
  filter: TaskLogFilter,
  pageSize: number
): number | undefined => {
  const lastPage = pages[pages.length - 1]
  if (!lastPage || lastPage.log.length === 0) return undefined

  const summary = lastPage.logSummary
  if (!summary) {
    return lastPage.log.length >= pageSize ? pages.length : undefined
  }

  const totalAvailable =
    filter === 'all'
      ? summary.infos + summary.warnings + summary.errors
      : filter === 'info'
        ? summary.infos
        : filter === 'warning'
          ? summary.warnings
          : summary.errors

  const totalLoaded = pages.reduce((sum, page) => sum + page.log.length, 0)

  return totalLoaded < totalAvailable ? pages.length : undefined
}

export const filterTaskLogsByType = (
  logs: TaskLog[],
  filter: TaskLogFilter
): TaskLog[] => {
  if (filter === 'all') return logs
  return logs.filter((log) => log.type === filter)
}

export const shouldUseClientFallback = (
  filter: TaskLogFilter,
  serverLogsCount: number
): boolean => filter !== 'all' && serverLogsCount === 0

export const extractLogsSummary = (
  pages: ApiTask[]
): TaskLogsSummary | undefined => {
  const summary = pages[pages.length - 1]?.logSummary
  if (!summary) return undefined

  return {
    info: summary.infos,
    warning: summary.warnings,
    error: summary.errors,
  }
}
